import { useEffect, useState } from 'react';

// Escribe cada palabra de `words`, la deja un momento, la borra y pasa a la
// siguiente -- en loop infinito.
const useTypewriterLoop = (words, { typeSpeed = 60, deleteSpeed = 30, pauseTime = 1400, startDelay = 600 } = {}) => {
  const [text, setText] = useState('');

  useEffect(() => {
    let wordIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timeoutId;

    const tick = () => {
      const currentWord = words[wordIndex];

      if (!deleting) {
        charIndex += 1;
        setText(currentWord.slice(0, charIndex));
        if (charIndex === currentWord.length) {
          timeoutId = setTimeout(() => {
            deleting = true;
            tick();
          }, pauseTime);
          return;
        }
        timeoutId = setTimeout(tick, typeSpeed);
      } else {
        charIndex -= 1;
        setText(currentWord.slice(0, charIndex));
        if (charIndex === 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
        }
        timeoutId = setTimeout(tick, deleteSpeed);
      }
    };

    const startTimeout = setTimeout(tick, startDelay);
    return () => {
      clearTimeout(startTimeout);
      clearTimeout(timeoutId);
    };
  }, [words, typeSpeed, deleteSpeed, pauseTime, startDelay]);

  return text;
};

export default useTypewriterLoop;
